import "./s.css";
import React from "react";
import { assetUrl } from "../../../utils/assetUrl";

const WHATSAPP_URL =
  "https://api.whatsapp.com/send?phone=%2B5492604417126&text=";

const ItemDetail = ({ product }) => {
  const whatsappLink =
    WHATSAPP_URL +
    encodeURIComponent(
      `Hola, me gustaría consultar por ${product.Titulo}.`
    );

  return (
    <div className="detail">
      <div className="detailImg">
        <img src={assetUrl(product.imagen)} alt={product.Titulo} />
      </div>
      <div className="detailText">
        <h1>{product.Titulo}</h1>
        <p>VINO TINTO</p>
        <br />
        <p className="descripcion">{product.Descripcion}</p>
        <p>
          <b>Indicación de Procedencia:</b> {product.IndicacionDeProcedencia}
        </p>
        <p>
          <b>Georreferencia del viñedo:</b> {product.Georreferencia}
        </p>
        {product.AnioPlantacion && (
          <p>
            <b>Año de plantación del viñedo:</b> {product.AnioPlantacion}
          </p>
        )}
        <p>
          <b>Cosecha:</b> {product.Cosecha}
        </p>
        <p>{product.PartidaLimitada}</p>
        <p>
          <b>Pedido mínimo:</b> caja por 6 botellas. Podés armar tu caja
          combinando las líneas de vinos que prefieras. Te la enviamos a
          domicilio.
        </p>
        <div className="botones">
          <div className="boton">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <button type="button">Consultar por WhatsApp</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemDetail;
